import React from "react";

interface ProgressBarProps {
  progress: number; // Progress percentage (0-100)
  color?: string; // Optional color prop for customizing the bar color
  showPercentage?: boolean; // Optional value for displaying percentage option
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  color = "bg-indigo-600",
  showPercentage = true,
}) => {
  return (
    <div className="w-full">
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div
          className={`${color} h-full rounded-full transition-all duration-300`}
          style={{ width: `${progress}%` }}></div>
      </div>

      {showPercentage && (
        <div className="text-right mt-2">
          <span className="text-sm font-medium text-gray-700">{progress}%</span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
